import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import useTranslation from "@babackapp/translations/use-translation";
import useQuickStats from "../lib/use-quick-stat";
import { discountColor } from "./colors";
import { QuickStatCard } from "./quick-stat-card";

export default function QuickStatDiscountCard() {
  const t = useTranslation();
  const stats = useQuickStats("discount");
  const { data: shop } = useCurrentShopSuspense();

  return (
    <QuickStatCard
      count={stats.count}
      value={stats.value}
      currency={shop.preferences.currency}
      evolution={5}
      title={t("analyticsDashboard.resolutionTypes.discount")}
      subtitle={t("analyticsDashboard.quickStats.discount")}
      percentage={stats.percentage}
      color={discountColor}
    />
  );
}
